import './normalize.css';
import "./i18n";
import React from "react";
import ReactDOM from "react-dom";
import './output.css'
import "./index.scss";
import 'semantic-ui-css/semantic.min.css';
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { icons } from "./assets/icons";
import { Provider } from "react-redux";
import getStore from "./redux/store/store";
import { PersistGate } from "redux-persist/integration/react";
import { startChecking } from "./redux/actions/auth";
import 'react-toastify/dist/ReactToastify.css';
import {
  clearChunkReloadCooldown,
  setupChunkLoadRecovery,
} from './utils/chunkLoadRecovery';

setupChunkLoadRecovery();

React.icons = icons;

const { store, persistor } = getStore();

// Rehidratar sesión desde localStorage antes del primer render de App.
// Evita que !uid en el primer frame dispare Redirect a /signin con F5.
const rehydrateSessionFromStorage = () => store.dispatch(startChecking());

ReactDOM.render(
  <Provider store={store}>
    <PersistGate
      loading={null}
      persistor={persistor}
      onBeforeLift={rehydrateSessionFromStorage}
    >
      <App />
    </PersistGate>
  </Provider>,
  document.getElementById("root")
);

// Allow a future deploy to trigger recovery again after a successful load.
window.setTimeout(clearChunkReloadCooldown, 30_000);

reportWebVitals();
